import React, { Component } from 'react';

import menu from '../../data/menu';
import MenuItem from '../menu-item/menu-item';
import MenuFeature from '../menu-feature/menu-feature';

class Menu extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="c-menu">
        <div className="c-menu--welcome">
          <p className="c-menu--welcome__text">Our menu has an extensive number of dishes, all with delicious, unique flavour only found at JK's. Certain menu items will have icons on them, which have different meanings - as follows:</p>
          <p className="c-menu--welcome__text"><span>&#x1F336;</span> - Spice factor: More peppers, more spice!</p>
          <p className="c-menu--welcome__text"><span>&#x1F95C;</span> - Dish contains nuts</p>
          <p className="c-menu--welcome__text"><span>&#x1F952;</span> - Vegetarian dish</p>
          <p className="c-menu--welcome__text">Before ordering, please speak to our staff if you have special requirements due to food alergies or intolerances. Gluten free options are available with many dishes.</p>
          <hr className="c-menu--welcome__seperator" />
        </div>
        <div className="c-menu--container">
          <MenuFeature title="Special Set Meals">
            <p className="c-menu--feature__text"><i>Minimum of 2 people - £15 per person</i></p>
            <hr className="c-menu--seperator" />
            <p className="c-menu--feature__text"><b>Appetiser:</b></p>
            <p className="c-menu--feature__text">Mixed platter of barbeque spare ribs, spring rolls, prawn toast, crispy sweet &amp; sour won tons and crispy seaweed.</p>
            <hr className="c-menu--seperator__small" />
            <p className="c-menu--feature__text"><b>Main Course:</b></p>
            <p className="c-menu--feature__text">Choose one main meal (menu items 25-85 and 105-186) per person, served with fried rice (excludes egg fried rice &amp; noodle dishes).</p>
            <br />
            <p className="c-menu--feature__text">Comes with prawn crackers and a can of pop each.</p>
            <hr className="c-menu--seperator__small" />
            <p className="c-menu--feature__text"><i>Extra costs apply to some choices:</i></p>
            <p className="c-menu--feature__text">Special (chicken, char siu &amp; prawns) add <b>£0.50</b></p>
            <p className="c-menu--feature__text">Deep fried fish add <b>£1.50</b></p>
            <p className="c-menu--feature__text">Mock duck or mock chicken add <b>£1.50</b></p>
            <p className="c-menu--feature__text">Sweet and sour mixed in batter/cantonese style add <b>£2.00</b></p>
            <p className="c-menu--feature__text">King prawns/seafood add <b>£2.00</b></p>
            <p className="c-menu--feature__text">Roast duck add <b>£2.50</b></p>
          </MenuFeature>
        </div>
        <hr className="c-menu--seperator" />
        <div className="c-menu--container">
          <MenuItem title="Soups" dishes={menu.soups} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Appetisers" dishes={menu.appetisers} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Egg Fried Rice Dishes" dishes={menu.eggFriedRiceDishes} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Noodle Dishes" dishes={menu.noodleDishes} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Sweet and Sour Dishes" dishes={menu.sweetAndSourDishes} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Chef's Special Dishes" description="Choose either deep fried fish or fillet steak, then pair with any option from number 34 to 51. Options 52 to 61 are seperate dishes." dishes={menu.chefsSpecialDishes} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Main Dishes" dishes={menu.mainDishes} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Extraordinary Dishes" dishes={menu.extraordinaryDishes} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Vegetarian Rice And Noodle Dishes" dishes={menu.vegetarianRiceAndNoodleDishes} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Chef's Special Vegetarian Dishes" dishes={menu.chefsSpecialVegetarianDishes} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Mixed Vegetable or Mushroom Dishes" dishes={menu.mixedVegetableOrMushroomDishes} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Tofu Dishes" dishes={menu.tofuDishes} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Alternative Dishes" dishes={menu.alternativeDishes} />
        </div>
        <div className="c-menu--container">
          <MenuItem title="Sides" dishes={menu.sides} />
        </div>
        {/* <div className="c-menu--container">
          <MenuItem title="Drinks" dishes={menu.drinks} />
        </div> */}
      </div>
    );
  }
}

export default Menu;